import { createApiClient } from './apiClient';
import { API_BASE_URL } from '../config';
import {
  TransferFundsResponse,
  TransferMarketFundsRequest,
  validateTransferMarketFundsRequest,
} from './fundTransferContracts';

const marketFundTransferApi = createApiClient({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export async function transferMarketFunds(
  token: string | null,
  payload: TransferMarketFundsRequest
): Promise<TransferFundsResponse> {
  const validation = validateTransferMarketFundsRequest(payload);
  if (!validation.success) {
    return { success: false, message: validation.message };
  }

  const headers: Record<string, string> = {};
  if (token) headers.Authorization = `Bearer ${token}`;

  const resp = await marketFundTransferApi.post<TransferFundsResponse>(
    '/transfer-market-funds',
    validation.data,
    { headers }
  );

  return resp.data;
}
